import { useCallback, useEffect, useRef, useState } from 'react';
import { api, ApiError } from './api';

// 拉取单条详情（/api/<resource>/<id> → {data}，含 lines）。id 变化时自动重取。
export function useDetail<T>(endpoint: string | null) {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const seq = useRef(0);

  const load = useCallback(async () => {
    if (!endpoint) { setData(null); return; }
    const my = ++seq.current;
    setLoading(true);
    setError(null);
    try {
      const d = await api.detail<T>(endpoint);
      if (my !== seq.current) return;
      setData(d);
    } catch (e) {
      if (my !== seq.current) return;
      setError(e instanceof ApiError ? e.message : '详情加载失败');
      setData(null);
    } finally {
      if (my === seq.current) setLoading(false);
    }
  }, [endpoint]);

  useEffect(() => { void load(); }, [load]);

  return { data, loading, error, reload: () => void load() };
}
